// extracted by mini-css-extract-plugin
export var bold = "style-module--bold--3562f";
export var calculatorFont = "style-module--calculatorFont--74651";
export var errorIcon = "style-module--errorIcon--f8052";
export var icon = "style-module--icon--42eab";
export var isDisabled = "style-module--isDisabled--7fb62";
export var small = "style-module--small--3341f";
export var textCenter = "style-module--textCenter--18855";